import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './CustomFormFields.scss';
import { Checkbox } from '@salesforce/design-system-react';
import { IconSettings } from '@salesforce/design-system-react';

export const BooleanField = ({ enabled, required, label, fieldName, handleChange, defaultValue, error }) => {
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    setChecked(defaultValue);
  }, [defaultValue]);

  return (
    <div className='boolean-field'>
      <IconSettings iconPath='/assets'>
        <Checkbox
          labels={{ label }}
          disabled={!enabled}
          required={required}
          name={fieldName}
          errorText={error}
          checked={checked}
          onChange={(e) => {
            setChecked(e.target.checked);
            handleChange(e, { fieldName, value: e.target.checked });
          }}
        />
      </IconSettings>
    </div>
  );
};

BooleanField.propTypes = {
  enabled: PropTypes.bool,
  required: PropTypes.bool,
  label: PropTypes.string,
  fieldName: PropTypes.string,
  handleChange: PropTypes.func,
  defaultValue: PropTypes.bool,
  error: PropTypes.string,
};
